import { FC, memo } from 'react';

import { GoodsFilterForm, IGoodsFilterForm } from './GoodsFilterForm';

export const GoodsFilter: FC<IGoodsFilterForm> = memo((props) => <GoodsFilterForm {...props} />);
